import React from 'react';
import {UpIcon, DownIcon, LeftIcon, RightIcon} from './Icons';
import {CONSTANTS} from '../../ZoomImage.utils';
import {ZoomContext} from '../../index';
/**
 * ScrollMenu
 *  - The Up/Down/Left/Right Menu buttons that let you navigate the image
 */
export function ScrollMenu() {
  const {updateScroll} = React.useContext(ZoomContext);

  const onLeftClick = () => updateScroll(CONSTANTS.DIRECTION.LEFT);

  const onRightClick = () => updateScroll(CONSTANTS.DIRECTION.RIGHT);

  const onTopClick = () => updateScroll(CONSTANTS.DIRECTION.UP);

  const onBottomClick = () => updateScroll(CONSTANTS.DIRECTION.DOWN);

  return (
    <div className='scrollMenuBlock'>
      <div className='scrollMenuBlock_left' onClick={onLeftClick}>
        <LeftIcon className='icon' />
      </div>
      <div className='scrollMenuBlock_middle'>
        <div onClick={onTopClick}>
          <UpIcon className='icon' />
        </div>
        <div onClick={onBottomClick}>
          <DownIcon className='icon' />
        </div>
      </div>
      <div className='scrollMenuBlock_right' onClick={onRightClick}>
        <RightIcon className='icon' />
      </div>
    </div>
  );
}

ScrollMenu.propTypes = {};
